import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-75059166")

_pushScopeId("data-v-75059166")
const _hoisted_1 = { class: "UserCreateForm" }
const _hoisted_2 = { class: "UserCreateForm__header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Редактирование пользователя")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Создание пользователя")
const _hoisted_6 = { class: "body__label" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Редактируйте основную информацию о пользователе")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Укажите основную информацию о пользователе")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Изменить")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Создать")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_close = _resolveComponent("icon-close")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_s_password = _resolveComponent("s-password")!
  const _component_s_checkbox = _resolveComponent("s-checkbox")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, [
        (_ctx.isUpdate)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _hoisted_4
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.isCreate)
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _hoisted_5
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_icon_close, {
        class: "header__close",
        onClick: _ctx.emitClose
      }, null, 8, ["onClick"])
    ]),
    _createVNode("form", {
      class: "UserCreateForm__body",
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitHandler && _ctx.submitHandler(...args)), ["prevent"]))
    }, [
      _createVNode("label", _hoisted_6, [
        (_ctx.isUpdate)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _hoisted_7
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.isCreate)
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _hoisted_8
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_s_input, {
        "is-invalid": Boolean(_ctx.v$.name.$errors.length),
        placeholder: "Имя и фамилия пользователя",
        value: _ctx.state.name,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.name = $event))
      }, null, 8, ["is-invalid", "value"]),
      _createVNode(_component_s_input, {
        placeholder: "Телефон пользователя",
        value: _ctx.state.phone,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.phone = $event)),
        "is-invalid": Boolean(_ctx.v$.phone.$errors.length),
        maska: {
                    mask: '+7 (###) ###-##-##',
                }
      }, null, 8, ["value", "is-invalid", "maska"]),
      _createVNode(_component_s_input, {
        placeholder: "E-mail пользователя",
        value: _ctx.state.email,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.email = $event)),
        "is-invalid": Boolean(_ctx.v$.email.$errors.length)
      }, null, 8, ["value", "is-invalid"]),
      _createVNode(_component_s_password, {
        placeholder: "Пароль пользователя",
        "is-invalid": Boolean(_ctx.v$.password.$errors.length),
        value: _ctx.state.password,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.password = $event))
      }, null, 8, ["is-invalid", "value"]),
      _createVNode(_component_s_checkbox, {
        theme: "green",
        label: "Может видеть все заказы компании",
        value: _ctx.state.is_advanced,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.is_advanced = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_s_button, {
        loading: _ctx.loading,
        type: "submit",
        class: "green"
      }, {
        default: _withId(() => [
          (_ctx.isUpdate)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_9
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.isCreate)
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _hoisted_10
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["loading"])
    ], 32)
  ]))
})